import { render, staticRenderFns } from "./EmptyPages.vue?vue&type=template&id=5990a89c&"
import script from "./EmptyPages.vue?vue&type=script&lang=js&"
export * from "./EmptyPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports